import { CLOUDINARY_IMAGE_URL } from 'src/utils/constants/ApiConstants';
import { BUSINESS_TYPE } from 'src/utils/constants/AppConstants';
import { UserTypes } from 'src/utils/constants/stringConstants';
import { checkIsTvod } from 'src/utils/TvodHelper/tvodHelper';

import {
  ContentPartnerDetailsTypes,
  ContentPartnerImageType
} from '../../types';

// method to determine if content is accessible for particular user
export const getIsContentAccessible = (packType: string) => {
  let isContentAccessible = false;
  if (packType === BUSINESS_TYPE.SVOD) {
    isContentAccessible = true;
  }
  return isContentAccessible;
};

// returns billing type of content
export const contentBillingType = (type: string, billingType: string) => {
  let contentType = '';
  if (type === BUSINESS_TYPE.TVOD || type === BUSINESS_TYPE.TVOD_DOWNLOADABLE) {
    contentType = BUSINESS_TYPE.TVOD;
  } else if (isPremiumBusinessType(type, billingType)) {
    contentType = BUSINESS_TYPE.PREMIUM;
  }
  return contentType;
};

// Business type check for getting premium content
export const isPremiumBusinessType = (
  type: string,
  billingType: string,
  isEduauraa = false
) => {
  if (
    type === BUSINESS_TYPE.PREMIUM ||
    type === BUSINESS_TYPE.PREMIUM_DOWNLOADABLE ||
    billingType === BUSINESS_TYPE.PREMIUM ||
    isEduauraa
  ) {
    return true;
  }
  return false;
};

// Joystick icon check & play5 banner button check
export const isJoystickIcon = (item: any) => {
  if (item && item.asset_type === 101 && 'gamify' in item) {
    return true;
  }
  return false;
};

export const premiumIconFlagBasedOnContent = (
  businessType: string,
  premiumTagFromInitialLaunch = false,
  zeePlexFlagFromOffer: boolean
) => {
  let flag = premiumTagFromInitialLaunch;
  if (checkIsTvod(businessType)) {
    flag = zeePlexFlagFromOffer;
  }
  return flag;
};

// function to check if it is tvod
export const checkForZeeplexIcon = (
  businessType: string,
  zeePlexFlagFromOffer: boolean
) => {
  return (
    zeePlexFlagFromOffer &&
    businessType &&
    (businessType.toLowerCase() === BUSINESS_TYPE.TVOD ||
      businessType.toLowerCase() === BUSINESS_TYPE.TVOD_DOWNLOADABLE ||
      businessType.toLowerCase() === BUSINESS_TYPE.TVOD_PREMIUM)
  );
};

export const checkForPremiumIcon = (
  isContentAccessible: boolean,
  billingType: string,
  isPremiumContent: boolean,
  premiumFlagFromOffer: boolean,
  userType: string
) => {
  return (
    premiumFlagFromOffer &&
    !isContentAccessible &&
    billingType &&
    isPremiumContent &&
    userType !== UserTypes.PREMIUM
  );
};

export const contentDetailsList: object = {
  partnerId: 'content_partner_id',
  id: 'content_partner_id',
  name: 'content_partner_name',
  image: 'content_partner_images',
  rectangleDarkLogo: 'logo_rectangle_darkbg',
  rectangleWhiteLogo: 'logo_rectangle_whitebg',
  circleDarkLogo: 'logo_circle_darkbg',
  circleWhiteLogo: 'logo_circle_whitebg',
  purchaseImage: 'purchase_image',
  deeplinkUrl: 'content_partner_deeplink'
};

export const partnerImageURLGenerator = (
  contentPartnerDetails: ContentPartnerDetailsTypes,
  secondTag: string
) => {
  // secondTag is to select the type of Image (eg: 'logo_rectangle_darkbg')
  if (contentPartnerDetails?.content_partner_images && secondTag) {
    const { content_partner_id = '', content_partner_images } =
      contentPartnerDetails || {};
    const logoType =
      content_partner_images[secondTag as keyof ContentPartnerImageType];
    return logoType
      ? `${CLOUDINARY_IMAGE_URL}master/${content_partner_id}/${secondTag}/${logoType}.png`
      : '';
  }
};
